import React from 'react';

const Settings = () => {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const handleShowVersion = () => {
    // fetch('/api/version')
    fetch(`${apiBaseUrl}/api/public/version`)
      .then(response => response.json())
      .then(data => alert(`App Version: ${data.version}`))
      .catch(error => console.error('Error fetching version:', error));
  };

  return (
    <div className="p-8">
      <h2 className="text-2xl font-bold mb-4">Settings</h2>
      <button
        onClick={handleShowVersion}
        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
      >
        Show Version
      </button>
    </div>
  );
};

export default Settings;
